module.exports = __webpack_public_path__ + "media/images/internet-d4ef1771cab0b071ad4354b3f267c49e.png";